import { Box, useMediaQuery } from "@mui/material";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import {
  Outlet,
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { TitleStyled } from "./shared/styles";
import { getPageTitle } from "./shared/utils";
import { Bounce, ToastContainer } from "react-toastify";
import { ForgotPassword } from "./components/forgot-password";
import { HomeContainer } from "./components/home/home-container";
import { Login } from "./components/login";
import { LeftMenu } from "./components/menus/left-menu";
import { TopMenu } from "./components/menus/top-menu";
import { SignUp } from "./components/sign-up";
import { TransactionsContainer } from "./components/transactions/transactions-container";
import { WalletsContainer } from "./components/wallets/wallets-container";
import { AgendaContainer } from "./components/agenda/agenda-container";
import { ProfileContainer } from "./components/profile/profile-container";
import { useGetUser } from "./hooks/useGetUser";
import { TransactionDetailContainer } from "./components/transactions/transaction-detail-container";
import { MultiplePaymentsDetail } from "./components/home/multiple-payments-detail";
import { Footer } from "./shared/footer/footer";

const LayoutWithMenu = () => {
  const { isMenuOpen } = useSelector((state) => state.settings);
  const isMobile = useMediaQuery("(max-width: 600px)");
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const pageTitle = getPageTitle(pathname);

  const { userId } = useGetUser();

  useEffect(() => {
    if (!userId) {
      navigate("/");
    }
  }, [userId, navigate]);

  return (
    <Box display={"flex"}>
      <LeftMenu />
      <Box width={"100%"}>
        <TopMenu />
        <Box
          padding={
            isMobile
              ? "80px 12px 16px 12px"
              : `80px 24px 24px ${isMenuOpen ? "212px" : "144px"}`
          }
        >
          {pageTitle && (
            <TitleStyled sx={{ marginBottom: "24px" }}>{pageTitle}</TitleStyled>
          )}
          <Outlet />
        </Box>
        <Box padding={isMobile ? "0 12px" : `0 24px 0 ${isMenuOpen ? "212px" : "144px"}`}>
          <Footer />
        </Box>
      </Box>
    </Box>
  );
};

function App() {
  return (
    <>
      <ToastContainer
        position="bottom-center"
        theme={"dark"}
        icon={""}
        pauseOnHover={false}
        hideProgressBar={true}
        transition={Bounce}
        autoClose={4000}
        closeButton={false}
      />
      <Router>
        <Routes>
          <Route path="/" exact element={<Login />} />
          <Route path="/forgot-password" exact element={<ForgotPassword />} />
          <Route path="/sign-up" exact element={<SignUp />} />
          <Route element={<LayoutWithMenu />}>
            <Route path="/home" element={<HomeContainer />} />
            <Route
              path="/home/multiple-payments/:multiplePaymentsId"
              element={<MultiplePaymentsDetail />}
            />
            <Route path="/profile" element={<ProfileContainer />} />
            <Route path="/transactions" element={<TransactionsContainer />} />
            <Route
              path="/transactions/:transactionId"
              element={<TransactionDetailContainer />}
            />
            <Route path="/wallets" element={<WalletsContainer />} />
            <Route path="/agenda" element={<AgendaContainer />} />
          </Route>
        </Routes>
      </Router>
    </>
  );
}

export default App;
